// Centralised "click → route" decision for any calendar item shape.
// We branch on the item's primitive type AND activity binding so each
// surface gets its own context-rich detail screen instead of the legacy
// generic "/event/:id" page.
//
// Activity-bound events (have `activity_id` set) → ActivityDetail
// Study sessions (event with session_kind=study) → ActivityDetail too
// Plain events → legacy /event/:id
// Tasks / chores / polls → in-page deep link on /plan
export function calendarItemRoute(item) {
  if (!item || !item.id) return "/today";
  // Activity-bound events get the rich detail screen.
  if (item.activity_id) {
    return `/activity/${item.activity_id}/event/${item.id}`;
  }
  const t = item.type || item.kind;
  if (t === "todo")  return `/plan?tab=todos#${item.id}`;
  if (t === "chore") return `/plan?tab=chores#${item.id}`;
  if (t === "poll")  return `/plan?tab=polls#${item.id}`;
  // Default: plain event / study session / holiday template event.
  return `/event/${item.id}`;
}
